import React from "react";
import { useTranslation } from "react-i18next";
import videoHero from "./videoHero.mp4";
import imageHero from "./imageHero.webp";
import "./Hero.css";

function Hero() {
  const { t } = useTranslation();

  return (
    <section className="hero ">
      <div className="hero-container">
        {/* Видео вместо картинки */}
        <video
          className="hero-video"
          autoPlay="autoplay"
          muted
          playsInline
          loop
          poster={imageHero}
        >
          <source src={videoHero} type="video/mp4" />
          Ваш браузер не поддерживает видео.
        </video>

        <div className="hero-content text_style-white">
          <h1 className="hero-title h1_mod_size ">
            <span>{t("hero.title")}</span>
          </h1>
          <p className="hero-subtitle text_mod_size-normal text_style-white">
            {t("hero.subtitle")}
          </p>
        </div>
      </div>
    </section>
  );
}

export default Hero;
